import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import bootstrap from 'bootstrap'
import LoginHandler from './LoginHandler';
import axios from 'axios';

const root = ReactDOM.createRoot(document.getElementById('root'));

const axiosIntance = axios.create({withCredentials:true})

root.render(
  <React.StrictMode>
    <App axios={axiosIntance} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
